import React from "react";
import CarouselVotosPartidos from "../components/Carousel/CarouselVotosPartidos";
import FooterLayout from "../components/Footer/Footer";
import { useEleccion } from "../contexts/eleccionContext";
import { useNomenclator } from "../contexts/nomenclatorContext";
import styled from 'styled-components/macro';

const ResultadosVotosPartidosCarousel = () => {

    const nomenclator = useNomenclator();
    const election = useEleccion();
    const partidosData = []

    election.selectedCamara.partotabla.map((candidatoPartidos) => {
        const { codpar: posicion, vot, pvot, cantotabla } = candidatoPartidos.act
        const { nombre: nombrePartido, color, codpar } = nomenclator.partidos[posicion - 1]

        partidosData.push({ codpar, nombrePartido, color, pvot, vot, cantotabla })
        return codpar && nombrePartido && color && vot && pvot && cantotabla
    })


    return (
        <ContenedorCarousel>
            <CarouselVotosPartidos partidosData={partidosData} />
            <FooterLayout estadisticas />
        </ContenedorCarousel>
    )
}

const ContenedorCarousel = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 65vh;
    margin-bottom: 67px;
    justify-content: space-between;
    padding: 0 5%;
`

export default ResultadosVotosPartidosCarousel